var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRegistrationIcon = function SvgRegistrationIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.71,
    height: 14.905,
    viewBox: "0 0 11.71 14.905",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6294",
    "data-name": "Grupo 6294",
    transform: "translate(-11683.679 6766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2843",
    "data-name": "Grupo 2843",
    transform: "translate(11683.679 -6766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2842",
    "data-name": "Grupo 2842",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1797",
    "data-name": "Caminho 1797",
    d: "M57.257,1.953H55.908v-.6c0-.2-.213-.284-.408-.284H54.454A1.587,1.587,0,0,0,52.874,0,1.615,1.615,0,0,0,51.3,1.066H50.266c-.2,0-.39.089-.39.284v.6H48.527a1.508,1.508,0,0,0-1.49,1.437V13.557a1.428,1.428,0,0,0,1.49,1.348h8.729a1.428,1.428,0,0,0,1.49-1.348V3.39A1.508,1.508,0,0,0,57.257,1.953Zm-6.671-.177h.976a.39.39,0,0,0,.337-.319,1.029,1.029,0,0,1,.976-.8,1.011,1.011,0,0,1,.958.8.39.39,0,0,0,.355.319H55.2V3.2H50.586Zm7.452,11.781a.72.72,0,0,1-.781.639H48.527a.72.72,0,0,1-.781-.639V3.39a.8.8,0,0,1,.781-.727h1.348v.9a.373.373,0,0,0,.39.337H55.5a.39.39,0,0,0,.408-.337v-.9h1.348a.8.8,0,0,1,.781.727V13.557Z",
    transform: "translate(-47.037 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1798",
    "data-name": "Caminho 1798",
    d: "M102.092,230.422a.355.355,0,0,0-.5-.018l-1.136,1.082-.479-.5a.355.355,0,0,0-.5-.018.373.373,0,0,0,0,.515l.727.745a.32.32,0,0,0,.248.106.355.355,0,0,0,.248-.106l1.384-1.313a.337.337,0,0,0,.02-.476Z",
    transform: "translate(-97.603 -222.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1799",
    "data-name": "Caminho 1799",
    d: "M202.984,256.034H198.9a.355.355,0,1,0,0,.71h4.081a.355.355,0,0,0,0-.71Z",
    transform: "translate(-193.403 -247.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1800",
    "data-name": "Caminho 1800",
    d: "M102.092,146.83a.355.355,0,0,0-.5-.018l-1.136,1.082-.479-.5a.355.355,0,0,0-.5-.018.373.373,0,0,0,0,.515l.727.745a.319.319,0,0,0,.248.106.355.355,0,0,0,.248-.106l1.384-1.313a.337.337,0,0,0,.02-.476Z",
    transform: "translate(-97.603 -141.737)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1801",
    "data-name": "Caminho 1801",
    d: "M202.984,172.442H198.9a.355.355,0,1,0,0,.71h4.081a.355.355,0,1,0,0-.71Z",
    transform: "translate(-193.403 -166.586)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1802",
    "data-name": "Caminho 1802",
    d: "M102.092,314.013a.355.355,0,0,0-.5-.018l-1.136,1.082-.479-.5a.355.355,0,0,0-.5-.018.373.373,0,0,0,0,.515l.727.745a.319.319,0,0,0,.248.106.355.355,0,0,0,.248-.106l1.384-1.313a.337.337,0,0,0,.02-.476Z",
    transform: "translate(-97.603 -303.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1803",
    "data-name": "Caminho 1803",
    d: "M202.984,339.626H198.9a.355.355,0,0,0,0,.71h4.081a.355.355,0,0,0,0-.71Z",
    transform: "translate(-193.403 -328.092)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRegistrationIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/registration_icon.b4158934.svg";
export { ForwardRef as ReactComponent };